
import React from 'react';
import EntityDetailLayout from '../../EntityDetailLayout';
import { FileX } from 'lucide-react';

interface TransactionNotFoundProps {
  onClose: () => void;
}

const TransactionNotFound: React.FC<TransactionNotFoundProps> = ({ onClose }) => {
  return (
    <EntityDetailLayout title="Transaction Not Found" onClose={onClose}>
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <FileX className="h-12 w-12 text-muted-foreground mb-4" />
        <h3 className="text-lg font-medium mb-2">Transaction Not Found</h3>
        <p className="text-muted-foreground max-w-md">
          The transaction you're looking for doesn't exist or has been removed.
        </p>
      </div>
    </EntityDetailLayout>
  );
};

export default TransactionNotFound;
